import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services/http-common.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-element-priority-form",
  templateUrl: "./element-priority-form.component.html",
  styleUrls: ["./element-priority-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementPriorityFormComponent extends BaseFormComponent<Element> {
  @Input() PriorityName: string;
  gridColumns: form_control[] = [];
  dataList: Element[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.setColumns();
  }
  onChange($event: any) {
    this.loadData();
  }
  loadData() {
    this.dataList = [];
    var filters: GridFilter[] = [];
    filters.push({ Filed: "ElementGroupId", Value: this.formGroup.get("ElementGroupId").value, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    this.httpCommonService
      .GetFilterGrid<PagingDataResult<Element>>("Element/GetFilterGrid", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: PagingDataResult<Element>) => {
          if (data) {
            this.dataList = data.Data.sort((a, b) => a[this.PriorityName] - b[this.PriorityName]);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  async setColumns() {
    this.orignalColumns = [];
    this.orignalColumns.push(<form_control>{
      label: "طبقه عامل",
      controlType: FormControlTypes.dropdown,
      modelName: "ElementGroupId",
      textType: "text",
      disabled: false,
      name: "ElementGroupId",
      order: 0,
      formVisible: true,
      listVisible: false,
      required: true,
      apiName: "Lookup",
      systemName: "HRM",
      category: "ElementGroup",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.columns = this.orignalColumns;
    this.model = <Element>{};
    this.setFormGroup(this.model);
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            (data as form_control[]).forEach((x) => {
              if (x.name == "Title") {
                x.disabled = true;
                x.listVisible = true;
                x.order = 0;
              } else if (x.name == this.PriorityName) {
                x.listVisible = true;
                x.order = 1;
              } else x.listVisible = false;
            });
            this.gridColumns = (data as form_control[]).sort((a, b) => a.order - b.order);
          }
          this.cd.markForCheck();
        },
        (error) => this.getFailedHelper(error)
      );
  }
  async save() {
    this.httpCommonService
      .bulkUpdate(this.apiName.split("/")[0], this.dataList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.close();
        },
        (error) => this.sts.showDialog(`خطا در ذخیره اطلاعات:${Utilities.getHttpResponseMessage(error)}`, "خطا")
      );
  }
}
